import { Box, Table, Tr, Th, Text, Thead, Tbody, Td } from '@chakra-ui/react';
import * as _ from 'lodash';
import React from 'react';

import { CreditAgreement } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/common';

const getTypeSpecificFields = (baseField: any) => {
  switch (baseField.type) {
    case 'boolean':
    case 'optionalBoolean':
      return <Text>externalBooleanTrue: {baseField.externalBooleanTrue}</Text>;
    case 'currency':
    case 'optionalCurrency':
      return <Text>currencyCode: {baseField.currencyCode}</Text>;
    case 'date':
    case 'optionalDate':
      return <Text>externalDateFormat: {baseField.externalDateFormat}</Text>;
    case 'dateTime':
    case 'optionalDateTime':
      return (
        <>
          <Text>
            externalDateTimeFormat: {baseField.externalDateTimeFormat}
          </Text>
          {baseField.defaultTz && <Text>defaultTz: {baseField.defaultTz}</Text>}
        </>
      );
    default:
      return '';
  }
};

type LoanProductBaseFieldConfigProps = {
  baseFields: CreditAgreement.DataTapeField.BaseConfig[];
};
export const LoanProductBaseFieldConfig = ({
  baseFields,
}: LoanProductBaseFieldConfigProps) => {
  return (
    <Box mb="35px" width="100%">
      <Text fontWeight="bold" fontSize="18px">
        Base Field Configuration
      </Text>
      {baseFields.length === 0 && (
        <Text>
          There are currently no configurations for this loan product.
        </Text>
      )}
      {baseFields.length > 0 && (
        <Table borderWidth="1px">
          <Thead>
            <Tr>
              <Th>Field Name</Th>
              <Th>Type</Th>
              <Th>Default Value</Th>
              <Th>Other Properties</Th>
            </Tr>
          </Thead>
          <Tbody>
            {_.map(baseFields, (baseField: any) => {
              return (
                <Tr key={baseField.field}>
                  <Td>{baseField.field}</Td>
                  <Td>{baseField.type}</Td>
                  <Td>{baseField.defaultTo || '-'}</Td>
                  <Td>{getTypeSpecificFields(baseField)}</Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      )}
    </Box>
  );
};
